import React from 'react';
import './Button.scss';

const Button = (props) => {
    return (
        <button
            className = {"eb-btn " + (props.className ? props.className : '')}
            type = {props.type ? props.type : ''}
            title = {props.title ? props.title : ''}
            id = {props.id ? props.id : ''}
            onClick = {props.buttonOnClick ? ((e) => props.buttonOnClick(e)) : () => {} }
            {...props.otherAttribs}
        >
            {props.value}
        </button>
    );
}

export default Button;
